import * as yup from "yup";

export const ComapnyAddValidation = yup.object({
    companyName: yup.string().min(3).max(25).required(),
});
